var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 13H5v-2h14v2z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Icon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Icon;

Icon.default = Icon;
